import axios from 'axios';

export const fetchApiData = url => async () => {
  return await axios.get(url);
};



// WEBPACK FOOTER //
// ./src/auth/index.js